import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";

import Slideshow from "../../assets/Slideshow/Slideshow"; 


import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";


const Lo5Self = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo5-headings">
                <h1>Exploration of Self</h1>
                <p>Throughout this semester I have to try and explore what I want to do in the future</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
            </div>

            <div className="content-lo5">
                <div className="content-lo5-self">
                    <div className="content-lo5-self-text">
                    
                        <h1>What am I interested in?</h1>
                        <p>
                            This semester, I found myself mostly active when working on the creative task especially those involving design. While
                            developing products for our group studio, I took a lead in creating the logo, designing the posters for the client, and 
                            also doing some visual materials to represent our brand. These experience made me realize how I enjoy the creative side
                            of ICT and how naturally I feel when doing this kind of work.
                        </p>
                        <h1>Creative task and workshop</h1>
                        <p>
                            One of the highlight was attending a Blender Workshop, where I got to experiment with 3D modelling, I found it really fun and 
                            managed to complete all the tasks. It showed me that I enjoyed in learning with creative tools.
                        </p>
                        <h1>What am I leaning into?</h1>
                        <p>
                            I've also started working on strengthening my technological skills, particularly in web development. To challenge myself, I
                            decided to create this portfolio website with React. While it was difficult at first, continuously working with React has
                            helped me build confidence and improve my skills. I've learned to value the way that creative and technical work can support one another.

                        </p>
                        <h1>Plan for the future?</h1>
                        <p>
                            Looking ahead, I intend to pursue the Mobile App Development minor in semester four. I had a great time experimenting with Flutter during
                            semester 3, and I'd like to build on that by learning more about app development in a structured way. Although I initially picked Cyber
                            Security because I was interested in the field networking , I've since realized that my true passion is developing creative, user-focused
                            applications. I believe that Mobile App Development will allow me to combine my design interests and technological skills in a way that is
                            in line with my goals.
                        </p>
                        
                    </div>

                    {/* <div className="content-lo5-self-slideshow">
                        <Slideshow images={images} />

                    </div>

                    <div className="content-lo5-self-slideshow2">
                        <Slideshow images={images} />

                    </div> */}
                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo5Self;